import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  CreateButton,
  TopToolbar,
  ReferenceManyField,
  SingleFieldList,
  ChipField,
  FieldProps,
  useRecordContext,
  FilterLiveSearch,
  SavedQueriesList,
  FunctionField,
} from "react-admin";
import { Link } from "react-router-dom";
import { AsideStyledCard } from "../../components/common";
import { CardContent } from "@mui/material";
import { formatDate } from "../../../utils/common";

const ListActions = (props: any) => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

const StationChipField: React.FC<FieldProps> = () => {
  const record = useRecordContext();

  return (
    <Link to={`/stations/${record?.fleetId}/${record?.id}/show`}>
      <ChipField source="name" />
    </Link>
  );
};

const Aside = () => (
  <AsideStyledCard>
    <CardContent>
      <FilterLiveSearch source="name" label="车队名称" alwaysOn />
      <FilterLiveSearch source="description" label="车队描述" alwaysOn />
      <SavedQueriesList />
    </CardContent>
  </AsideStyledCard>
);

export const FleetList: React.FC = (props: any) => {
  return (
    <List {...props} actions={<ListActions />} aside={<Aside />}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="name" label="车队名称" />
        <TextField source="description" label="车队描述" />
        <FunctionField
          label="所属公司或部门"
          sortBy="organizations"
          render={(record: any) =>
            record.organizations && record.organizations.length > 0
              ? `${record.organizations.join(", ")}`
              : `${record.branch?.name}`
          }
        />
        <FunctionField
          label="上次更新"
          sortBy="updatedBy"
          render={(record: any) =>
            `${record.updatedBy ?? ""}更新于${formatDate(record.updatedAt)}`
          }
        />
        <ReferenceManyField
          label="站点"
          reference={`fleets/stations`}
          target="fleetId"
        >
          <SingleFieldList linkType={false}>
            <StationChipField />
          </SingleFieldList>
        </ReferenceManyField>
        <EditButton />
      </Datagrid>
    </List>
  );
};
